export default __webpack_public_path__ + "static/media/chatbot.9fa6df06.png";